<template>
    <form class="col-md-10 mx-auto" ref="form">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="redirectToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card">
                <div class="card-header bg-primary text-white">
                    <page-title :title="$t('company.edit')"></page-title>
                </div>

                <div class="card-body" v-if="model.company">
                    <company-editor :company="model.company" :max-length="4000"></company-editor>
                </div>
            </div>

            <div class="text-center mt-3">
                <button type="button" class="btn btn-primary btn" @click="onSubmit" :disabled="saving">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>

    </form>
</template>

<script>
    import CompanyCompponent from '../../components/company/Company';
    import PageTitle from '../../components/common/PageTitle';
    import companyService from '../../services/company.service';
    import { Company } from '@/models/models';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            skipValidation: {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },
        components: {
            "company-editor": CompanyCompponent,
            PageTitle
        },
        data() {
            return {
                model: {
                    company: new Company()
                },
                loading: false,
                saving: false,
            }
        },
        mounted: function () {
            if (!this.isNew) {
                this.load();
            } else {
                // Ignore
            }
        },
        computed: {
            ...mapGetters(['notificationDuration', 'claims']),
            isNew: function () {
                return this.id === undefined;
            },
            hasUpdateRights() {
                return this.claims.nomenclatureTypes.update;
            },
        },
        methods: {
            load() {
                this.loading = true;

                companyService
                    .getInputModelById(this.id)
                    .then(result => {
                        if (result.data) {
                            this.model.company = new Company(result.data);
                        }
                    })
                    .catch(err => {
                        // Todo
                    })
                    .then(() => { this.loading = false; });
            },
            async onSubmit() {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let validForm = false;

                if (this.skipValidation) {
                    validForm = true;
                } else {
                    validForm = await this.$validator.validateAll();
                }

                if (!validForm) {
                    this.$vs.notify({
                        title: this.$t('buttons.save.btnText'),
                        text: this.$t('notifications.validationError'),
                        color: 'warning',
                        time: this.notificationDuration,
                    })
                    return;
                }

                this.saving = true;

                if (this.isNew) {

                } else {
                    companyService.update(this.model.company)
                        .then((response) => {
                            this.$vs.notify({
                                title: this.$t('buttons.save.btnText'),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.notificationDuration,
                            })

                            this.redirectToList();
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('buttons.save.btnText'),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.notificationDuration
                            })
                        })
                        .then(() => { this.saving = false; });
                }
            },
            redirectToList() {
                this.$router.push({ path: '/company/list' });
            }
        }
    }
</script>

